import { render, staticRenderFns } from "./PageSignUp.vue?vue&type=template&id=20bafb4c&"
import script from "./PageSignUp.vue?vue&type=script&lang=js&"
export * from "./PageSignUp.vue?vue&type=script&lang=js&"
import style0 from "./PageSignUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports